import React from 'react'
import BreadCrum from '../components/BreadCrum'
import Container from '../components/Container'
import Meta from '../components/Meta'

const Wishlist = () => {
  return (
    <>
        <Meta title='Wishlist'/>
        <BreadCrum title='Wishlist' />
        <Container class1="wishlist-wrapper home-wrapper-2 py-3">
            <div className="row">
                <div className="col-3">
                    <div className="wishlist-card position-relative">
                        <img src="images/cross.svg" alt="cross" className="position-absolute cross" />
                        <div className="wishlist-card-image">
                            <img src="images/watch.jpg" alt="watch" className="img-fluid w-100" />
                        </div>
                        <div className="py-3 px-3">
                            <h5 className="title">Lorem, ipsum dolor.</h5>
                            <h6 className="price">$ 100</h6>
                        </div>
                    </div>
                </div>
                <div className="col-3">
                    <div className="wishlist-card position-relative">
                        <img src="images/cross.svg" alt="cross" className="position-absolute cross" />
                        <div className="wishlist-card-image">
                            <img src="images/watch.jpg" alt="watch" className="img-fluid w-100" />
                        </div>
                        <div className="py-3 px-3">
                            <h5 className="title">Lorem, ipsum dolor.</h5>
                            <h6 className="price">$ 100</h6>
                        </div>
                    </div>
                </div>
                <div className="col-3">
                    <div className="wishlist-card position-relative">
                        <img src="images/cross.svg" alt="cross" className="position-absolute cross" />
                        <div className="wishlist-card-image">
                            <img src="images/watch.jpg" alt="watch" className="img-fluid w-100" />
                        </div>
                        <div className="py-3 px-3">
                            <h5 className="title">Lorem, ipsum dolor.</h5>
                            <h6 className="price">$ 100</h6>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    </>
  )
}

export default Wishlist